<template>

  <div class="item">
    <NuxtLink class="bimg" :to="link">     
      <img loading="lazy" :src="sizeM" :alt="'Meme by ' + authorName">
    </NuxtLink>

    <div class="video_info">
      <NuxtLink :to="authorLink" class="ttl">
       {{ authorName }}
      </NuxtLink> 
    </div>

  </div>

</template>


<script setup lang="ts">

const emits = defineEmits(['clickPhoto'])

interface PageProps {
  title: string;
  sizeM: string;
  sizeBig: string;
  authorName: string;
  authorLink: string;
  link: string;
}

const props = defineProps<PageProps>()
 
const clickPhoto = () => {
  emits('clickPhoto')
}
  
</script>
   

<style scoped>
  
  
.gallery{
    width: 100%;
}

.photos_gallery{
  display: block;
  overflow-y: hidden;
  text-align: left;
  width: 100%;
  height: 100px;
     white-space: nowrap;
     position: relative;
}
.photos_gallery::before{
  content: ' ';
   box-shadow: white -150px 0em 70px -90px inset;
  position: absolute;
  width: 100%;
  height: 100%;
  pointer-events: none;
}
.photos_gallery a{

}
.photos_gallery > a > img{
    width: 100px;
    height: 100px;
    border-radius: 3px;
}

.videos_gallery{
    display: block;
    text-align: left;
    margin-top: 20px;
}

.gallery{
    overflow-x: hidden;
       white-space: nowrap;
       position: relative;
}
.gallery::before{
  content: ' ';
   box-shadow: white -150px 0em 70px -90px inset;
  position: absolute;
  width: 100%;
  height: 100%;
     z-index: 2;
     pointer-events: none;
}

/*  */
.item{
  display: flex
;
    position: relative;
    flex-shrink: 0;
    flex-direction: column;
    gap: 0.5rem;
}


.item .video_info{

}

.item .video_info .ttl{
    display: block;
    text-transform: capitalize;
     font-weight: bold;
}
.item .video_info .hint{
    color: gray;
    display: block;
   font-size: 0.85rem;
}

.item > .bimg{
  display: flex
;
    border-radius: 3px;
    cursor: pointer;
    position: relative;
}
.item > .bimg img{
  border-radius: 5px;
    width: auto;
    object-fit: cover;
    height: 220px;
} 
.videos_gallery > .item > .bimg > img{
    width: 100%;
    height: auto;
    margin-top: -10px;
} 


</style>
